module.exports = __webpack_public_path__ + "static/media/whatsapp.4025a2c2.svg";